import React from 'react'
import Link from 'gatsby-link'


const Header = ({ siteTitle , siteDescript }) => (
  <header> 
    <nav className="headerbar">   
    <ul>
      <li className="header_link">
          <Link to="/" className="header_link"><h1 className="header_title">{siteTitle}</h1></Link>
          <h2 className="header_descript">{siteDescript}</h2>
      </li>
      <li className="nav"><Link activeClassName="activenav" to="/about/">About</Link></li>
      <li className="nav"><Link activeClassName="activenav" to="/contact/">Contact</Link></li>
    </ul>
    </nav>
  </header>

)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js